import produce from 'immer';

import {
  CREATE_FEE_PAYMENT_CUSTOM_FIELD_FAILURE,
  EDIT_FEE_CUSTOM_FIELD_SEQUENCE_FAILURE,
  EDIT_FEE_CUSTOM_FIELD_SEQUENCE_SUCCESS,
  EDIT_FEE_PAYMENT_CUSTOM_FIELD_FAILURE,
  EDIT_FEE_PAYMENT_CUSTOM_FIELD_SUCCESS,
  EDIT_PAYMENT_CUSTOM_FIELD_SEQUENCE_FAILURE,
  EDIT_PAYMENT_CUSTOM_FIELD_SEQUENCE_SUCCESS,
  FETCH_FEE_PAYMENT_CUSTOM_FIELD_FAILURE,
  FETCH_FEE_PAYMENT_CUSTOM_FIELD_LIST_FAILURE,
  FETCH_FEE_PAYMENT_CUSTOM_FIELD_LIST_SUCCESS,
  FETCH_FEE_PAYMENT_CUSTOM_FIELD_SUCCESS,
} from '@actions/feePaymentCustomField';

const initialState: IConfigFeePaymentCustomFieldStore = {
  currentfeePaymentCustomField: null,
  feeCustomFields: null,
  paymentCustomFields: null,
  error: null,
};

export default (state: IConfigFeePaymentCustomFieldStore = initialState, action: any) =>
  produce(state, (draftState: IConfigFeePaymentCustomFieldStore) => {
    switch (action.type) {
      case FETCH_FEE_PAYMENT_CUSTOM_FIELD_SUCCESS:
      case EDIT_FEE_PAYMENT_CUSTOM_FIELD_SUCCESS:
        draftState.currentfeePaymentCustomField = action.response;
        draftState.error = null;

        return;

      case FETCH_FEE_PAYMENT_CUSTOM_FIELD_LIST_SUCCESS:
        const getFieldList = (fieldType: FeePaymentFieldType) =>
          action.response.filter((elem) => elem.feePaymentFieldType === fieldType);
        draftState.feeCustomFields = getFieldList(FeePaymentFieldType.FEE);
        draftState.paymentCustomFields = getFieldList(FeePaymentFieldType.PAYMENT);
        draftState.error = null;

        return;

      case EDIT_FEE_CUSTOM_FIELD_SEQUENCE_SUCCESS:
        draftState.feeCustomFields = action.response;
        draftState.error = null;

        return;

      case EDIT_PAYMENT_CUSTOM_FIELD_SEQUENCE_SUCCESS:
        draftState.paymentCustomFields = action.response;
        draftState.error = null;

        return;

      case CREATE_FEE_PAYMENT_CUSTOM_FIELD_FAILURE:
      case EDIT_FEE_PAYMENT_CUSTOM_FIELD_FAILURE:
        draftState.error = action.error;

        return;

      case FETCH_FEE_PAYMENT_CUSTOM_FIELD_FAILURE:
        draftState.error = action.error;

        return;

      case EDIT_PAYMENT_CUSTOM_FIELD_SEQUENCE_FAILURE:
        draftState.error = action.error;

        return;
      case EDIT_FEE_CUSTOM_FIELD_SEQUENCE_FAILURE:
        draftState.error = action.error;

        return;

      case FETCH_FEE_PAYMENT_CUSTOM_FIELD_LIST_FAILURE:
        draftState.feeCustomFields = null;
        draftState.paymentCustomFields = null;
        draftState.error = null;

        return;
    }
  });
